import React from 'react';
import styled from '@emotion/styled';
import { theme } from '../../../styles/theme';

export const PreviewImageButton = styled.button`
  display: block;
  width: 100%;
  padding: 0;
  border: none;
  background: transparent;
  cursor: zoom-in;
  position: relative;

  img {
    display: block;
    width: 100%;
  }

  &:hover img,
  &:focus-visible img {
    opacity: 0.92;
  }

  &:focus-visible {
    outline: 2px solid var(--login-primary);
    outline-offset: -2px;
  }

  & > span {
    position: absolute;
    right: 12px;
    bottom: 12px;
    padding: 6px 10px;
    border-radius: 8px;
    background: rgba(15, 23, 42, 0.72);
    color: #fff;
    font-size: ${theme.typography.fontSize.sm};
    font-weight: 600;
    pointer-events: none;
    opacity: 0;
    transition: opacity 0.2s ease;
  }

  &:hover > span,
  &:focus-visible > span {
    opacity: 1;
  }
`;

export default function PreviewClickableImage({ src, alt, onClick, ariaLabel }) {
  return (
    <PreviewImageButton
      type="button"
      onClick={onClick}
      aria-label={ariaLabel || `View full-size ${alt}`}
    >
      <img src={src} alt={alt} />
      <span>Click to enlarge</span>
    </PreviewImageButton>
  );
}
